import { Box, Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { X, XOctagon } from 'react-feather';

export const useStyles = makeStyles(() => ({
  container: {
    minHeight: 56,
    padding: 16,
    borderRadius: 10,
    backgroundColor: '#FFDCE0',
  },
  text: {
    fontWeight: 400,
    fontSize: 15,
    color: '#910314',
    textOverflow: 'wrap',
  },
  close: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

type Props = {
  showAlert: boolean;
  onCloseAlert: () => void;
  className?: string;
};

const PersonValidationAlert = ({
  onCloseAlert,
  showAlert,
  className,
}: Props): JSX.Element => {
  const classes = useStyles();

  if (!showAlert) {
    return <div data-testid="empty-message" />;
  }

  return (
    <Grid
      container
      className={clsx(classes.container, className)}
      data-testid="full-message"
    >
      <Box display="flex" sx={{ width: '100%' }}>
        <Box sx={{ width: 26, marginRight: 10 }}>
          <Box>
            <XOctagon color="#B80016" />
          </Box>
        </Box>
        <Box flexGrow={1} className={classes.text}>
          Para continuar por favor contáctanos al WhatsApp 2503-2772 para
          brindarte asistencia
        </Box>
        <Box sx={{ width: 26 }}>
          <Box className={classes.close}>
            <X
              data-testid="close-icon"
              color="#B80016"
              onClick={onCloseAlert}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default PersonValidationAlert;
